/*
 * oem-drawer-filter.jsx
 * Copyright (c) Harman International Industries, Incorporated, 2024 - 2025
 * All rights reserved.
 */
import {
  Button,
  Drawer,
  FormControl,
  FormControlLabel,
  FormLabel,
  Radio,
  RadioGroup,
  Typography,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { useEffect, useRef, useState } from "react";
import PropTypes from "prop-types";
import "./oem-drawer-filter.css";
import APIManager from "../../../Services/ApiManager/ApiManager";
import PopupDialog from "../../../Components/PopupDialog";
import apiLeveL from "./api-level.json";
import { OEMDrawerFilterAll } from "./oem-drawr-filter-all";
import { OEMDrawerFilterOem } from "./oem-drawr-filter-oem";
import { OEMDrawerFilter3rdParty } from "./oem-drawr-filter-3rdparty";

export const OEMDrawerFilter = ({
  openFilter,
  toggleDrawer,
  categoryObjectList,
  modelObjectList,
  handleFilterApiCalls,
  channelListchecked,
  setChannelListchecked,
  channelSelections,
  setChannelSelections,
  categorySelection,
  setCategorySelection,
  modelSelections,
  setModelSelections,
  paymentSelections,
  setPaymentSelections,
  countrySelections,
  setCountrySelections,
  statusSelections,
  setStatusSelections,
  apiLevelSelections,
  setApiLevelSelections,
  ecuTypeSelections,
  setEcuTypeSelections,
}) => {
  const [countryObjectList, setCountryObjectList] = useState([]);
  const [ECUTypesObjectList, setECUTypesObjectList] = useState([]);
  const [apiObjectList, setApiObjectList] = useState([]);
  const [countryObjResponse, setCountryObjResponse] = useState([]);

  const [channelOpen, setChannelOpen] = useState(false);
  const [statusOpen, setStatusOpen] = useState(false);
  const [categoryOpen, setCategoryOpen] = useState(false);
  const [modelOpen, setModelOpen] = useState(false);
  const [ecuOpen, setECUOpen] = useState(false);
  const [countryOpen, setCountryOpen] = useState(false);
  const [ApiLevelOpen, setApiLevelOpen] = useState(false);
  const [paymentOpen, setPaymentOpen] = useState(false);

  const [selectAllCategoryFlag, setSelectAllCategoryFlag] = useState(false);
  const [selectAllModelFlag, setSelectAllModelFlag] = useState(false);
  const [selectAllCountryFlag, setSelectAllCountryFlag] = useState(false);
  const [selectAllECUFlag, setSelectAllECUFlag] = useState(false);
  const [selectAllApiFlag, setSelectAllApiFlag] = useState(false);

  const [statusListchecked, setStatusListchecked] = useState([]);
  const [categoryListChecked, setCategoryListChecked] = useState([]);
  const [modelListChecked, setModelListChecked] = useState([]);
  const [ecuListchecked, setECUListchecked] = useState([]);
  const [countryListchecked, setCountryListchecked] = useState([]);
  const [apiLevelListchecked, setApiLevelListchecked] = useState([]);
  const [paymentListchecked, setPaymentListchecked] = useState([]);

  const [searchCategory, setSearchCategory] = useState("");
  const [searchModel, setSearchModel] = useState("");
  const [searchECU, setSearchECU] = useState("");
  const [searchCountry, setSearchCountry] = useState("");
  const [searchApiLevel, setSearchApiLevel] = useState("");

  const [componentName, setComponentName] = useState("");
  const [openErrorPopup, setOpenErrorPopup] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const [headerMessage, setHeaderMessage] = useState("");

  const channelType = ["BETA", "STAGING", "PROD"];
  const statusArray = ["Approved", "Published"];
  const paymentArray = ["Premium App", "Free App"];

  const [appType, setAppType] = useState("All");

  const [showChannelError, setShowChannelError] = useState(false);
  const [showStatusError, setShowStatusError] = useState(false);
  const [showCategoryError, setShowCategoryError] = useState(false);
  const [showModelError, setShowModelError] = useState(false);
  const [showCountryError, setShowCountryError] = useState(false);
  const [showApilevelError, setShowApilevelError] = useState(false);
  const [showPaymentError, setShowPaymentError] = useState(false);
  const [tabChange, setTabChange] = useState(false);
  const categoriesList = useRef();
  const modelList = useRef();
  const ecuList = useRef();
  const countryList = useRef();
  const apiLevelList = useRef();

  // Helper function to get filter state key
  const getFilterStateKey = () => {
    const portfolioId = sessionStorage.getItem("portfolioId");
    return portfolioId && portfolioId !== "null" 
      ? `oemFilterState_${portfolioId}` 
      : null;
  };

  // Helper function to clear saved filter state from sessionStorage
  const clearSavedFilterState = () => {
    const filterStateKey = getFilterStateKey();
    if (filterStateKey) {
      try {
        sessionStorage.removeItem(filterStateKey);
        console.log("Cleared saved filter state for portfolio:", sessionStorage.getItem("portfolioId"));
      } catch (error) {
        console.error("Failed to clear saved filter state:", error);
      }
    }
  };

  // Helper function to save filter state to sessionStorage
  const saveFilterState = (filterState) => {
    const filterStateKey = getFilterStateKey();
    if (filterStateKey) {
      try {
        sessionStorage.setItem(filterStateKey, JSON.stringify(filterState));
        console.log("Filter state saved to sessionStorage for portfolio:", sessionStorage.getItem("portfolioId"));
      } catch (error) {
        console.error("Failed to save filter state to sessionStorage:", error);
      }
    }
  };

  const handlePopUpClose = () => {
    setOpenErrorPopup(false);
  };

  const handleChannelClick = () => {
    const willOpen = !channelOpen;

    if (willOpen) {
      setStatusOpen(false);
      setCategoryOpen(false);
      setModelOpen(false);
      setECUOpen(false);
      setCountryOpen(false);
      setApiLevelOpen(false);
      setPaymentOpen(false);
    }
    setChannelOpen(willOpen);
  };

  const handleStatusClick = () => {
    const willOpen = !statusOpen;
    if (willOpen) {
      setChannelOpen(false);
      setCategoryOpen(false);
      setModelOpen(false);
      setECUOpen(false);
      setCountryOpen(false);
      setApiLevelOpen(false);
      setPaymentOpen(false);
    }
    setStatusOpen(willOpen);
  };

  const handleCategoryClick = () => {
    const willOpen = !categoryOpen;
    if (willOpen) {
      setChannelOpen(false);
      setCategoryOpen(false);
      setModelOpen(false);
      setECUOpen(false);
      setCountryOpen(false);
      setApiLevelOpen(false);
      setPaymentOpen(false);
    }
    setCategoryOpen(willOpen);
  };

  const handleModelClick = () => {
    const willOpen = !modelOpen;
    if (willOpen) {
      setChannelOpen(false);
      setCategoryOpen(false);
      setModelOpen(false);
      setECUOpen(false);
      setCountryOpen(false);
      setApiLevelOpen(false);
      setPaymentOpen(false);
    }
    setModelOpen(willOpen);
  };

  const handleECUClick = () => {
    const willOpen = !ecuOpen;
    if (willOpen) {
      setChannelOpen(false);
      setCategoryOpen(false);
      setModelOpen(false);
      setECUOpen(false);
      setCountryOpen(false);
      setApiLevelOpen(false);
      setPaymentOpen(false);
    }
    setECUOpen(willOpen);
  };

  const handleCountryClick = () => {
    const willOpen = !countryOpen;
    if (willOpen) {
      setChannelOpen(false);
      setCategoryOpen(false);
      setModelOpen(false);
      setECUOpen(false);
      setCountryOpen(false);
      setApiLevelOpen(false);
      setPaymentOpen(false);
    }
    setCountryOpen(willOpen);
  };

  const handleApiLevelClick = () => {
    const willOpen = !ApiLevelOpen;
    if (willOpen) {
      setChannelOpen(false);
      setCategoryOpen(false);
      setModelOpen(false);
      setECUOpen(false);
      setCountryOpen(false);
      setApiLevelOpen(false);
      setPaymentOpen(false);
    }
    setApiLevelOpen(willOpen);
  };

  const handlePaymentClick = () => {
    const willOpen = !paymentOpen;
    if (willOpen) {
      setChannelOpen(false);
      setCategoryOpen(false);
      setModelOpen(false);
      setECUOpen(false);
      setCountryOpen(false);
      setApiLevelOpen(false);
      setPaymentOpen(false);
    }
    setPaymentOpen(willOpen);
  };

  const filteredCategory = Object.keys(categoryObjectList).filter((item) =>
    item.toLowerCase().includes(searchCategory.toLowerCase())
  );

  const filteredModel = Object.keys(modelObjectList).filter((item) =>
    item.toLowerCase().includes(searchModel.toLowerCase())
  );

  let filteredECUTypes = [];
  if (ECUTypesObjectList !== undefined && ECUTypesObjectList.length > 0) {
    filteredECUTypes = ECUTypesObjectList.filter((item) =>
      item.toLowerCase().includes(searchECU.toLowerCase())
    );
  }

  const filteredCountry = countryObjectList.filter((item) =>
    item.toLowerCase().includes(searchCountry.toLowerCase())
  );
  const filteredApiLevel =
    apiObjectList?.filter((item) => {
      const itemVal = Number.parseInt(item);
      const searchVal = Number.parseInt(searchApiLevel);

      if (!searchApiLevel || Number.isNaN(searchVal)) return true;

      return itemVal >= searchVal;
    }) || [];

  const handleChannelToggle = (value) => () => {
    const currentSelection = [...channelListchecked];
    const index = currentSelection.indexOf(value);

    if (index === -1) {
      currentSelection.push(value);
    } else {
      currentSelection.splice(index, 1);
    }

    setChannelListchecked(currentSelection);
    setChannelSelections((prev) => ({
      ...prev,
      [appType]: currentSelection,
    }));
  };
  const handleStatusToggle = (value) => () => {
    const currentIndex = statusListchecked.indexOf(value);
    const newChecked = [...statusListchecked];

    if (currentIndex === -1) {
      newChecked.push(value);
    } else {
      newChecked.splice(currentIndex, 1);
    }

    setStatusListchecked(newChecked);

    if (newChecked.length > 0) {
      setShowStatusError(false);
    }
  };

  const handleCategoryToggle = (value) => () => {
    const currentIndex = categoryListChecked.indexOf(value);

    const newChecked = [...categoryListChecked];

    if (currentIndex === -1) {
      newChecked.push(value);
    } else {
      newChecked.splice(currentIndex, 1);
    }

    setCategoryListChecked(newChecked);
    if (newChecked.length > 0) {
      setShowCategoryError(false);
    }
    categoriesList.current = newChecked.length;
  };

  const handleModelToggle = (value) => () => {
    const currentIndex = modelListChecked.indexOf(value);

    const newChecked = [...modelListChecked];

    if (currentIndex === -1) {
      newChecked.push(value);
    } else {
      newChecked.splice(currentIndex, 1);
    }

    setModelListChecked(newChecked);
    if (newChecked.length > 0) {
      setShowModelError(false);
    }
    modelList.current = newChecked.length;
  };

  const handleECUToggle = (value) => () => {
    const currentIndex = ecuListchecked.indexOf(value);

    const newChecked = [...ecuListchecked];

    if (currentIndex === -1) {
      newChecked.push(value);
    } else {
      newChecked.splice(currentIndex, 1);
    }

    setECUListchecked(newChecked);
    ecuList.current = newChecked.length;
  };

  const handleCountryToggle = (value) => () => {
    const currentIndex = countryListchecked.indexOf(value);

    const newChecked = [...countryListchecked];

    if (currentIndex === -1) {
      newChecked.push(value);
    } else {
      newChecked.splice(currentIndex, 1);
    }

    setCountryListchecked(newChecked);
    if (newChecked.length > 0) {
      setShowCountryError(false);
    }
    countryList.current = newChecked.length;
  };

  const handleAPILevelToggle = (value) => () => {
    const currentIndex = apiLevelListchecked.indexOf(value);

    const newChecked = [...apiLevelListchecked];

    if (currentIndex === -1) {
      newChecked.push(value);
    } else {
      newChecked.splice(currentIndex, 1);
    }

    setApiLevelListchecked(newChecked);
    if (newChecked.length > 0) {
      setShowApilevelError(false);
    }
    apiLevelList.current = newChecked.length;
  };

  const handlePaymentToggle = (value) => () => {
    const currentIndex = paymentListchecked.indexOf(value);

    const newChecked = [...paymentListchecked];

    if (currentIndex === -1) {
      newChecked.push(value);
    } else {
      newChecked.splice(currentIndex, 1);
    }

    setPaymentListchecked(newChecked);
    if (newChecked.length > 0) {
      setShowPaymentError(false);
    }
  };

  const handleApplyFilters = () => {
    let channelTypeObject = [];
    let portfolioContentStatusObj = [];

    const isChannelValid = channelListchecked.length > 0;
    setShowChannelError(!isChannelValid);

    const isStatusValid = statusListchecked.length > 0;
    setShowStatusError(!isStatusValid);

    const isCategoryValid = categoryListChecked.length > 0;
    setShowCategoryError(!isCategoryValid);

    const isModelValid = modelListChecked.length > 0;
    setShowModelError(!isModelValid);

    const isCountryValid = countryListchecked.length > 0;
    setShowCountryError(!isCountryValid);

    const isApilevelValid = apiLevelListchecked.length > 0;
    setShowApilevelError(!isApilevelValid);

    const isPaymentValid = paymentListchecked.length > 0;
    setShowPaymentError(!isPaymentValid);

    if (
      !isChannelValid ||
      !isStatusValid ||
      !isCategoryValid ||
      !isModelValid ||
      !isCountryValid ||
      !isApilevelValid ||
      !isPaymentValid
    )
      return;
    let filteredChannelList = [...channelListchecked];

    if (appType === "3rd Party Apps") {
      filteredChannelList = channelListchecked.filter(
        (item) => item === "PROD"
      );
    }

    if (filteredChannelList.length === 3) {
      channelTypeObject.push(
        "PUBLISHED",
        "APPROVED_FOR_BETA",
        "APPROVED_FOR_STAGING",
        "APPROVED_FOR_PRODUCTION"
      );
      portfolioContentStatusObj.push(
        "APPROVED_FOR_BETA",
        "STAGING_APPROVAL_IN_REVIEW",
        "STAGING_APPROVAL_APPROVED",
        "PRODUCTION_APPROVAL_IN_REVIEW",
        "PRODUCTION_APPROVAL_APPROVED"
      );
    } else {
      filteredChannelList.forEach((channelType) => {
        switch (channelType) {
          case "BETA":
            channelTypeObject.push("APPROVED_FOR_BETA");
            portfolioContentStatusObj.push("APPROVED_FOR_BETA");
            break;
          case "STAGING":
            channelTypeObject.push(
              "APPROVED_FOR_PRODUCTION",
              "APPROVED_FOR_STAGING",
              "PUBLISHED"
            );
            portfolioContentStatusObj.push("STAGING_APPROVAL_APPROVED");
            break;
          case "PROD":
            channelTypeObject.push("APPROVED_FOR_PRODUCTION");
            portfolioContentStatusObj.push("PRODUCTION_APPROVAL_APPROVED");
            break;
          default:
            break;
        }
      });
    }

    let countryListData = countryObjResponse.map((country) => {
      if (countryListchecked.includes(country.name)) {
        return country.iso3Code;
      }
    });

    let data = {
      categories:
        Object.keys(categoryObjectList).length ===
        Object.keys(categoryListChecked).length
          ? ["ALL"]
          : categoryListChecked,
      ecuTypes:
        ECUTypesObjectList.length === ecuListchecked.length
          ? ["ALL"]
          : ecuListchecked,
      models:
        Object.keys(modelObjectList).length ===
        Object.keys(modelListChecked).length
          ? ["ALL"]
          : modelListChecked,
      //: Object.keys(modelListChecked),
      countries:
        countryObjectList.length === countryListchecked.length
          ? ["ALL"]
          : countryListData.filter((country) => country !== undefined),
      portfolioMgrReviewStatusList: portfolioContentStatusObj,
      contentStatusList: channelTypeObject,
      androidApiLevel:
        apiLevelListchecked.length === apiObjectList.length
          ? ["ALL"]
          : apiLevelListchecked,
      payments:
        paymentArray.length === paymentListchecked.length
          ? ["ALL"]
          : paymentListchecked,
      ...(appType === "OEM Apps" && { isOemApp: true }),
      ...(appType === "3rd Party Apps" && { isOemApp: false }),
    };

    setCategorySelection((prev) => ({
      ...prev,
      [appType]: categoryListChecked,
    }));
    setModelSelections((prev) => ({
      ...prev,
      [appType]: modelListChecked,
    }));
    setCountrySelections((prev) => ({
      ...prev,
      [appType]: countryListchecked,
    }));
    setPaymentSelections((prev) => ({
      ...prev,
      [appType]: paymentListchecked,
    }));
    setStatusSelections((prev) => ({
      ...prev,
      [appType]: statusListchecked,
    }));
    setApiLevelSelections((prev) => ({
      ...prev,
      [appType]: apiLevelListchecked,
    }));
    setEcuTypeSelections((prev) => ({
      ...prev,
      [appType]: ecuListchecked,
    }));

    // Save filter state to sessionStorage for persistence across navigation
    saveFilterState({
      appType: appType,
      channelListchecked: channelListchecked,
      categoryListChecked: categoryListChecked,
      modelListChecked: modelListChecked,
      ecuListchecked: ecuListchecked,
      countryListchecked: countryListchecked,
      apiLevelListchecked: apiLevelListchecked,
      statusListchecked: statusListchecked,
      paymentListchecked: paymentListchecked,
      lastAppliedFilterData: data,
      timestamp: Date.now(),
    });

    handleFilterApiCalls(data);
  };

  const handleAppTypeChange = (event) => {
    const newAppType = event.target.value;
    setAppType(newAppType);

    // Always trigger tab change when switching app types
    setTabChange(true);

    // Reset all filters to default values immediately
    setChannelListchecked(channelType);
    // Reset category selections
    // setCategoryListChecked(

    // Reset model selections
    // setModelListChecked(

    // Reset ECU selections
    // setECUListchecked(ECUTypesObjectList || []);

    // Reset country selections
    // setCountryListchecked(countryObjectList);

    // Reset all the select all flags
    setSelectAllCategoryFlag(false);
    setSelectAllModelFlag(false);
    setSelectAllCountryFlag(false);
    setSelectAllECUFlag(false);
    setSelectAllApiFlag(false);

    // Reset search states
    setSearchCategory("");
    setSearchModel("");
    setSearchECU("");
    setSearchCountry("");
    setSearchApiLevel("");

    // Reset error states
    setShowChannelError(false);
    setShowStatusError(false);
    setShowCategoryError(false);
    setShowModelError(false);
    setShowCountryError(false);
    setShowApilevelError(false);
    setShowPaymentError(false);

    // Clear saved filter state when changing app type
    clearSavedFilterState();
  };

  const handleResetChange = (event) => {
    setAppType("All");
    setChannelListchecked(channelType);
    setStatusListchecked(["Approved"]);
    setPaymentListchecked(paymentArray);

    setApiLevelListchecked(apiLeveL.map((item) => item.name));
    setApiObjectList(apiLeveL.map((item) => item.name));

    // Reset category selections
    setCategoryListChecked(
      Object.keys(categoryObjectList).filter((item) => item !== "")
    );

    // Reset model selections
    setModelListChecked(
      Object.keys(modelObjectList).filter((item) => item !== "")
    );

    // Reset ECU selections
    setECUListchecked(ECUTypesObjectList);

    // Reset country selections
    setCountryListchecked(countryObjectList);

    // Reset all the select all flags
    setSelectAllCategoryFlag(false);
    setSelectAllModelFlag(false);
    setSelectAllCountryFlag(false);
    setSelectAllECUFlag(false);
    setSelectAllApiFlag(false);

    // Reset search states
    setSearchCategory("");
    setSearchModel("");
    setSearchECU("");
    setSearchCountry("");
    setSearchApiLevel("");

    // Reset all the saved selections for each app type
    setCategorySelection({});
    setModelSelections({});
    setCountrySelections({});
    setPaymentSelections({});
    setStatusSelections({});
    setApiLevelSelections({});
    setEcuTypeSelections({});
    setChannelSelections({});

    // Reset all sections to collapsed state
    // setChannelOpen(false);
    // setStatusOpen(false);
    // setCategoryOpen(false);
    // setModelOpen(false);
    // setECUOpen(false);
    // setCountryOpen(false);
    // setApiLevelOpen(false);
    // setPaymentOpen(false);

    // Clear saved filter state when resetting
    clearSavedFilterState();
  };

  const handleUnselectCategory = () => {
    setSelectAllCategoryFlag(!selectAllCategoryFlag);
    if (selectAllCategoryFlag) {
      setCategoryListChecked(Object.keys(categoryObjectList));
      categoriesList.current = Object.keys(categoryObjectList).length;
    } else {
      setCategoryListChecked([]);
      categoriesList.current = 0;
    }
  };

  const handleUnselectModel = () => {
    setSelectAllModelFlag(!selectAllModelFlag);
    if (selectAllModelFlag) {
      setModelListChecked(Object.keys(modelObjectList));
      modelList.current = Object.keys(modelObjectList).length;
    } else {
      setModelListChecked([]);
      modelList.current = 0;
    }
  };

  const handleUnselectECU = () => {
    setSelectAllECUFlag(!selectAllECUFlag);
    if (selectAllECUFlag) {
      setECUListchecked(ECUTypesObjectList);
      ecuList.current = Object.keys(ECUTypesObjectList).length;
    } else {
      setECUListchecked([]);
      ecuList.current = 0;
    }
  };

  const handleUnselectCountry = () => {
    setSelectAllCountryFlag(!selectAllCountryFlag);
    if (selectAllCountryFlag) {
      setCountryListchecked(countryObjectList);
      countryList.current = Object.keys(countryObjectList).length;
    } else {
      setCountryListchecked([]);
      countryList.current = 0;
    }
  };

  const handleUnselectApiLevel = () => {
    setSelectAllApiFlag(!selectAllApiFlag);
    if (selectAllApiFlag) {
      setApiLevelListchecked(apiObjectList);
      apiLevelList.current = Object.keys(apiObjectList).length;
    } else {
      setApiLevelListchecked([]);
      apiLevelList.current = 0;
    }
  };

  const handleCategorySearch = (event) => {
    setSearchCategory(event.target.value);
  };

  const handleModelSearch = (event) => {
    setSearchModel(event.target.value);
  };

  const handleECUSearch = (event) => {
    setSearchECU(event.target.value);
  };

  const handleCountrySearch = (event) => {
    setSearchCountry(event.target.value);
  };

  const handleApiLevelSearch = (event) => {
    event.preventDefault();
    setSearchApiLevel(event.target.value);
  };

  const handleAllChannelsToggle = () => {
    if (channelListchecked.length === channelType.length) {
      setChannelListchecked([]); // uncheck all
    } else {
      setChannelListchecked(channelType); // select all
    }
  };
  const handleAllStatusToggle = () => {
    if (statusListchecked.length === statusArray.length) {
      setStatusListchecked([]);
    } else {
      setStatusListchecked(statusArray);
    }
  };
  const handleAllCategoryToggle = () => {
    if (
      filteredCategory.length > 0 &&
      filteredCategory.every((item) => categoryListChecked.includes(item))
    ) {
      const newChecked = categoryListChecked.filter(
        (item) => !filteredCategory.includes(item)
      );
      setCategoryListChecked(newChecked);
      categoriesList.current = newChecked.length;
    } else {
      const newChecked = [
        ...new Set([...categoryListChecked, ...filteredCategory]),
      ];
      setCategoryListChecked(newChecked);
      categoriesList.current = newChecked.length;
    }
  };
  const handleAllModelToggle = () => {
    if (modelListChecked.length === filteredModel.length) {
      setModelListChecked([]);
      modelList.current = 0;
    } else {
      setModelListChecked(filteredModel);
      modelList.current = Object.keys(filteredModel).length;
    }
  };
  const handleAllEcuToggle = () => {
    if (ecuListchecked.length === filteredECUTypes.length) {
      setECUListchecked([]);
      ecuList.current = 0;
    } else {
      setECUListchecked(filteredECUTypes);
      ecuList.current = filteredECUTypes.length;
    }
  };
  const handleAllCountryToggle = () => {
    if (
      filteredCountry.length > 0 &&
      filteredCountry.every((item) => countryListchecked.includes(item))
    ) {
      const newChecked = countryListchecked.filter(
        (item) => !filteredCountry.includes(item)
      );
      setCountryListchecked(newChecked); // uncheck all
      countryList.current = newChecked.length;
    } else {
      const newChecked = [
        ...new Set([...countryListchecked, ...filteredCountry]),
      ];
      setCountryListchecked(newChecked);
      countryList.current = newChecked.length;
    }
  };
  const handleAllApilevelToggle = () => {
    if (
      filteredApiLevel.length > 0 &&
      filteredApiLevel.every((item) => apiLevelListchecked.includes(item))
    ) {
      const newChecked = apiLevelListchecked.filter(
        (item) => !filteredApiLevel.includes(item)
      );
      setApiLevelListchecked(newChecked);
      apiLevelList.current = newChecked.length;
    } else {
      const newChecked = [
        ...new Set([...apiLevelListchecked, ...filteredApiLevel]),
      ];
      setApiLevelListchecked(newChecked);
      apiLevelList.current = newChecked.length;
    }
  };
  const handleAllPaymentToggle = () => {
    if (paymentListchecked.length === paymentArray.length) {
      setPaymentListchecked([]);
    } else {
      setPaymentListchecked(paymentArray);
    }
  };
  useEffect(() => {
    if (!tabChange) return;

    setChannelListchecked(channelType);
    setChannelSelections((prev) => ({
      ...prev,
      [appType]: [],
    }));
    setCategorySelection((prev) => ({ ...prev, [appType]: [] }));
    setEcuTypeSelections((prev) => ({ ...prev, [appType]: [] }));
    setModelSelections((prev) => ({ ...prev, [appType]: [] }));
    setPaymentSelections((prev) => ({ ...prev, [appType]: [] }));
    setStatusSelections((prev) => ({ ...prev, [appType]: [] }));
    setApiLevelSelections((prev) => ({ ...prev, [appType]: [] }));

    // Reset all error states
    setShowChannelError(false);
    setShowStatusError(false);
    setShowCategoryError(false);
    setShowModelError(false);
    setShowCountryError(false);
    setShowApilevelError(false);
    setShowPaymentError(false);
    setTabChange(false);
  }, [tabChange, appType]);

  const handleCountriesApiSuccess = (json) => {
    const countryNamesPopup = json.map((item) => item.name);
    setCountryObjResponse(json);
    setCountryObjectList(json.map((item) => item.name));
    const savedCountry = countrySelections[appType];
    setCountryListchecked(
      savedCountry?.length ? savedCountry : countryNamesPopup
    );

    if (tabChange) {
      setCountryListchecked(countryNamesPopup);
      setCountrySelections((prev) => ({ ...prev, [appType]: [] }));
      setTabChange(false);
    }
  };

  const handleApiError = (error) => {
    setComponentName("appError");
    setErrorMessage(error.message);
    setHeaderMessage(
      error.message === "jwt expired" ? "401 Token Expired" : "Error"
    );
    setOpenErrorPopup(true);
  };

  const handleEcuTypesApiSuccess = (json) => {
    setECUTypesObjectList(json);
    const savedEcu = ecuTypeSelections[appType];
    setECUListchecked(savedEcu?.length ? savedEcu : json);
    if (tabChange) {
      setECUListchecked(json);
      setEcuTypeSelections((prev) => ({ ...prev, [appType]: [] }));
      setTabChange(false);
    }
  };

  const handleCountriesRetrySuccess = (json) => {
    const countryNamesPopup = json.map((item) => item.name);
    setCountryObjResponse(json);
    setCountryObjectList(json.map((item) => item.name));
    setCountryListchecked(countryNamesPopup);
  };

  const handleEcuTypesRetrySuccess = (json) => {
    setECUTypesObjectList(json);
    setECUListchecked(json);
  };

  const retryPortfolioApis = () => {
    APIManager.getAdminCountries()
      .then(handleCountriesRetrySuccess)
      .catch((error) => {
        console.error("Countries API retry failed:", error);
      });

    APIManager.getOEMAdminEcuTypes()
      .then(handleEcuTypesRetrySuccess)
      .catch((error) => {
        console.error("ECU Types API retry failed:", error);
      });
  };

  const checkPortfolioAvailability = (retryAttempts = 0, maxRetries = 3) => {
    const currentPortfolioId = sessionStorage.getItem("portfolioId");
    if (currentPortfolioId && currentPortfolioId !== "null") {
      console.log("Portfolio ID became available, retrying API calls");
      retryPortfolioApis();
    } else if (retryAttempts < maxRetries) {
      retryAttempts++;
      console.log(
        `Portfolio not ready, retrying in 1 second (attempt ${retryAttempts}/${maxRetries})`
      );
      setTimeout(() => checkPortfolioAvailability(retryAttempts, maxRetries), 1000);
    } else {
      console.warn(
        "Max retry attempts reached, portfolio ID still not available"
      );
    }
  };

  useEffect(() => {
   
    if (openFilter) {
      setSearchCategory("");
      setSearchModel("");
      setSearchECU("");
      setSearchCountry("");
      setSearchApiLevel("");

      categoriesList.current = categoryListChecked.length;
      modelList.current = modelListChecked.length;
      countryList.current = countryListchecked.length;
      apiLevelList.current = apiLevelListchecked.length;
      ecuList.current = ecuListchecked.length;
    }

    const savedChannel = channelSelections[appType];
    setChannelListchecked(savedChannel?.length ? savedChannel : channelType);
    const savedCategories = categoryListChecked;

    setCategoryListChecked(
      savedCategories?.length
        ? savedCategories
        : Object.keys(categoryObjectList).filter((item) => item !== "")
    );

    const savedModels = modelSelections[appType];
    setModelListChecked(
      savedModels?.length
        ? savedModels
        : Object.keys(modelObjectList).filter((item) => item !== "")
    );

    const savedPayments = paymentSelections[appType];
    setPaymentListchecked(savedPayments?.length ? savedPayments : paymentArray);
    const savedStatus = statusSelections[appType];
    setStatusListchecked(savedStatus?.length ? savedStatus : ["Approved"]);
    const savedApiLevel = apiLevelSelections[appType];
    setApiLevelListchecked(
      savedApiLevel?.length ? savedApiLevel : apiLeveL.map((item) => item.name)
    );
    setApiObjectList(apiLeveL.map((item) => item.name));
    // Check if portfolio ID is available before calling APIs
    const portfolioId = sessionStorage.getItem("portfolioId");

    if (portfolioId && portfolioId !== "null") {
      // Call Countries API
      APIManager.getAdminCountries()
        .then(handleCountriesApiSuccess)
        .catch(handleApiError);

      // Call ECU Types API
      APIManager.getOEMAdminEcuTypes()
        .then(handleEcuTypesApiSuccess)
        .catch(handleApiError);
    } else {
      console.warn(
        "Countries and ECU Types API calls skipped: Portfolio ID is not available"
      );
      // Set empty data as fallback - this prevents the null API calls
      setCountryObjResponse([]);
      setCountryObjectList([]);
      setCountryListchecked([]);
      setECUTypesObjectList([]);
      setECUListchecked([]);

      // If portfolio is not available and filter is open, try to wait for it
      if (openFilter) {
        // Start checking for portfolio availability after a short delay
        setTimeout(() => checkPortfolioAvailability(), 500);
      }
    }
  }, [openFilter]);

  // Load saved filter state from sessionStorage when filter opens
  const restoreFilterStatesFromSavedState = (filterState) => {
    if (filterState.channelListchecked)
      setChannelListchecked(filterState.channelListchecked);
    if (filterState.categoryListChecked)
      setCategoryListChecked(filterState.categoryListChecked);
    if (filterState.modelListChecked)
      setModelListChecked(filterState.modelListChecked);
    if (filterState.ecuListchecked)
      setECUListchecked(filterState.ecuListchecked);
    if (filterState.countryListchecked)
      setCountryListchecked(filterState.countryListchecked);
    if (filterState.apiLevelListchecked)
      setApiLevelListchecked(filterState.apiLevelListchecked);
    if (filterState.statusListchecked)
      setStatusListchecked(filterState.statusListchecked);
    if (filterState.paymentListchecked)
      setPaymentListchecked(filterState.paymentListchecked);

    setChannelSelections((prev) => ({
      ...prev,
      [appType]: filterState.channelListchecked || [],
    }));
    setCategorySelection((prev) => ({
      ...prev,
      [appType]: filterState.categoryListChecked || [],
    }));
    setModelSelections((prev) => ({
      ...prev,
      [appType]: filterState.modelListChecked || [],
    }));
    setEcuTypeSelections((prev) => ({
      ...prev,
      [appType]: filterState.ecuListchecked || [],
    }));
    setCountrySelections((prev) => ({
      ...prev,
      [appType]: filterState.countryListchecked || [],
    }));
    setApiLevelSelections((prev) => ({
      ...prev,
      [appType]: filterState.apiLevelListchecked || [],
    }));
    setStatusSelections((prev) => ({
      ...prev,
      [appType]: filterState.statusListchecked || [],
    }));
    setPaymentSelections((prev) => ({
      ...prev,
      [appType]: filterState.paymentListchecked || [],
    }));
  };

  useEffect(() => {
    const portfolioId = sessionStorage.getItem("portfolioId");
    if (portfolioId && portfolioId !== "null" && openFilter) {
      const filterStateKey = `oemFilterState_${portfolioId}`;
      const savedFilterState = sessionStorage.getItem(filterStateKey);

      if (!savedFilterState) return;

      try {
        const filterState = JSON.parse(savedFilterState);
        console.log(
          "Loading saved filter state when filter opens for portfolio:",
          portfolioId
        );

        // Check if the saved state is not too old (24 hours)
        const maxAge = 24 * 60 * 60 * 1000; // 24 hours in milliseconds
        if (Date.now() - filterState.timestamp > maxAge) {
          console.log("Saved filter state is too old, clearing it");
          sessionStorage.removeItem(filterStateKey);
          return;
        }

        if (filterState.appType && filterState.appType !== appType) {
          console.log(
            "Restoring appType when filter opens:",
            filterState.appType
          );
          setAppType(filterState.appType);
          return;
        }

        // Restore filter states if they match the current appType
        if (filterState.appType === appType) {
          setTimeout(() => restoreFilterStatesFromSavedState(filterState), 100);
        }
      } catch (error) {
        console.error("Failed to parse saved filter state:", error);
        sessionStorage.removeItem(filterStateKey);
      }
    }
  }, [openFilter, appType]);

  useEffect(() => {
    setShowChannelError(channelListchecked.length === 0);
    setShowStatusError(statusListchecked.length === 0);
    setShowCategoryError(categoryListChecked.length === 0);
    setShowModelError(modelListChecked.length === 0);
    setShowCountryError(countryListchecked.length === 0);
    setShowApilevelError(apiLevelListchecked.length === 0);
    setShowPaymentError(paymentListchecked.length === 0);

    categoriesList.current = categoryListChecked.length;
    modelList.current = modelListChecked.length;
    countryList.current = countryListchecked.length;
    apiLevelList.current = apiLevelListchecked.length;
    ecuList.current = ecuListchecked.length;
  }, [
    channelListchecked,
    statusListchecked,
    categoryListChecked,
    modelListChecked,
    ecuListchecked,
    countryListchecked,
    apiLevelListchecked,
    paymentListchecked,
  ]);

  useEffect(() => {
    const portfolioId = sessionStorage.getItem("portfolioId");
    if (portfolioId && portfolioId !== "null") {
      const filterStateKey = `oemFilterState_${portfolioId}`;
      const savedFilterState = sessionStorage.getItem(filterStateKey);

      if (savedFilterState) {
        try {
          const filterState = JSON.parse(savedFilterState);
          console.log(
            "Checking for saved appType on component mount for portfolio:",
            portfolioId
          );

          const maxAge = 24 * 60 * 60 * 1000; // 24 hours in milliseconds
          if (Date.now() - filterState.timestamp > maxAge) {
            console.log("Saved filter state is too old on mount, clearing it");
            sessionStorage.removeItem(filterStateKey);
            return;
          }

          if (filterState.appType && filterState.appType !== appType) {
            console.log("Restoring appType:", filterState.appType);
            setAppType(filterState.appType);
          }
        } catch (error) {
          console.error(
            "Failed to parse saved filter state for appType:",
            error
          );
          sessionStorage.removeItem(filterStateKey);
        }
      }
    }
  }, [categoryObjectList, modelObjectList]);

  // Apply saved filter data automatically on component mount to restore filtered data
  useEffect(() => {
    const portfolioId = sessionStorage.getItem("portfolioId");
    if (
      portfolioId &&
      portfolioId !== "null" &&
      categoryObjectList &&
      modelObjectList
    ) {
      const filterStateKey = `oemFilterState_${portfolioId}`;
      const savedFilterState = sessionStorage.getItem(filterStateKey);

      if (savedFilterState) {
        try {
          const filterState = JSON.parse(savedFilterState);

          // Check if the saved state is not too old (24 hours)
          const maxAge = 24 * 60 * 60 * 1000; // 24 hours in milliseconds
          if (Date.now() - filterState.timestamp > maxAge) {
            sessionStorage.removeItem(filterStateKey);
            return;
          }

          if (filterState.appType === appType) {
            restoreFilterStatesFromSavedState(filterState);
          }
        } catch {
          sessionStorage.removeItem(filterStateKey);
        }
      }
    }
  }, [categoryObjectList, modelObjectList, appType]);

  return (
    <>
      <Drawer open={openFilter} onClose={toggleDrawer(false)} anchor="right">
        <div
          className="filterContainer"
          style={{
            display: "flex",
            flexDirection: "column",
            height: "100vh",
          }}
        >
          <div className="filterHeaderCls">
            <span>Filter</span>
            <span>
              <CloseIcon
                className="closeIconCls"
                onClick={toggleDrawer(false)}
              />
            </span>
          </div>
          <div
            className="filterContentCls"
            style={{
              flex: 1,
              overflowY: "auto",
              paddingBottom: "16px",
            }}
          >
            <div>
              <FormControl>
                <FormLabel
                  className="filterLabelCls"
                  id="demo-row-radio-buttons-group-label"
                >
                  Apps form
                </FormLabel>

                <div className="radioDivCls">
                  <RadioGroup
                    row
                    value={appType}
                    aria-labelledby="demo-row-radio-buttons-group-label"
                    name="row-radio-buttons-group"
                    onChange={handleAppTypeChange}
                    sx={{ flexWrap: "nowrap !important" }}
                  >
                    <FormControlLabel
                     className="radioButtonCls"
                      value="All"
                      control={<Radio size="small" />}
                      label="All"
                      slotProps={{
                        typography: {
                          sx: {
                            fontSize: "14px !important",
                            width: "max-content",
                          },
                        },
                      }}
                    />
                    <FormControlLabel
                     className="radioButtonCls"
                      value="OEM Apps"
                      control={<Radio size="small" />}
                      label="OEM Apps"
                      slotProps={{
                        typography: {
                          sx: {
                            fontSize: "14px !important",
                            width: "max-content",
                          },
                        },
                      }}
                    />
                    <FormControlLabel
                       className="radioButtonCls"
                      value="3rd Party Apps"
                      control={<Radio size="small" />}
                      label="3rd Party Apps"
                      slotProps={{
                        typography: {
                          sx: {
                            fontSize: "14px !important",
                            width: "max-content",
                          },
                        },
                      }}
                    />
                  </RadioGroup>
                </div>
              </FormControl>
            </div>
            {showChannelError && (
              <Typography
                sx={{
                  color: "red",
                  fontSize: "13px",
                  marginLeft: "16px",
                  marginTop: "4px",
                }}
              >
                Channel Type cannot be blank.please select a value!
              </Typography>
            )}
            {showStatusError && (
              <Typography
              className="errorMessageCls"
              >
                Status cannot be blank.please select a value!
              </Typography>
            )}
            {showCategoryError && (
              <Typography
                 className="errorMessageCls"
              >
                Category cannot be blank.please select a value!
              </Typography>
            )}
            {showModelError && (
              <Typography
                className="errorMessageCls"
              >
                Model cannot be blank.please select a value!
              </Typography>
            )}
            {showCountryError && (
              <Typography
             className="errorMessageCls"
              >
                Country cannot be blank.please select a value!
              </Typography>
            )}
            {showApilevelError && (
              <Typography
                className="errorMessageCls"
              >
                API Level cannot be blank.please select a value!
              </Typography>
            )}
            {showPaymentError && (
              <Typography
                className="errorMessageCls"
              >
                Payment cannot be blank.please select a value!
              </Typography>
            )}
            {appType === "All" && (
              <OEMDrawerFilterAll
                categoryObjectList={categoryObjectList}
                modelObjectList={modelObjectList}
                countryObjectList={countryObjectList}
                ECUTypesObjectList={ECUTypesObjectList}
                apiObjectList={apiObjectList}
                channelOpen={channelOpen}
                setChannelOpen={setChannelOpen}
                statusOpen={statusOpen}
                setStatusOpen={setStatusOpen}
                categoryOpen={categoryOpen}
                setCategoryOpen={setCategoryOpen}
                modelOpen={modelOpen}
                setModelOpen={setModelOpen}
                ecuOpen={ecuOpen}
                setECUOpen={setECUOpen}
                countryOpen={countryOpen}
                setCountryOpen={setCountryOpen}
                ApiLevelOpen={ApiLevelOpen}
                setApiLevelOpen={setApiLevelOpen}
                paymentOpen={paymentOpen}
                setPaymentOpen={setPaymentOpen}
                channelListchecked={channelListchecked}
                setChannelListchecked={setChannelListchecked}
                statusListchecked={statusListchecked}
                setStatusListchecked={setStatusListchecked}
                categoryListChecked={categoryListChecked}
                setCategoryListChecked={setCategoryListChecked}
                modelListChecked={modelListChecked}
                setModelListChecked={setModelListChecked}
                ecuListchecked={ecuListchecked}
                setECUListchecked={setECUListchecked}
                countryListchecked={countryListchecked}
                setCountryListchecked={setCountryListchecked}
                apiLevelListchecked={apiLevelListchecked}
                setApiLevelListchecked={setApiLevelListchecked}
                paymentListchecked={paymentListchecked}
                setPaymentListchecked={setPaymentListchecked}
                searchCategory={searchCategory}
                setSearchCategory={setSearchCategory}
                searchModel={searchModel}
                setSearchModel={setSearchModel}
                searchECU={searchECU}
                setSearchECU={setSearchECU}
                searchCountry={searchCountry}
                setSearchCountry={setSearchCountry}
                searchApiLevel={searchApiLevel}
                setSearchApiLevel={setSearchApiLevel}
                selectAllCategoryFlag={selectAllCategoryFlag}
                setSelectAllCategoryFlag={setSelectAllCategoryFlag}
                selectAllModelFlag={selectAllModelFlag}
                setSelectAllModelFlag={setSelectAllModelFlag}
                selectAllCountryFlag={selectAllCountryFlag}
                setSelectAllCountryFlag={setSelectAllCountryFlag}
                selectAllECUFlag={selectAllECUFlag}
                setSelectAllECUFlag={setSelectAllECUFlag}
                selectAllApiFlag={selectAllApiFlag}
                setSelectAllApiFlag={setSelectAllApiFlag}
                channelType={channelType}
                statusArray={statusArray}
                paymentArray={paymentArray}
                handleChannelClick={handleChannelClick}
                handleStatusClick={handleStatusClick}
                handleCategoryClick={handleCategoryClick}
                handleModelClick={handleModelClick}
                handleECUClick={handleECUClick}
                handleCountryClick={handleCountryClick}
                handleApiLevelClick={handleApiLevelClick}
                handlePaymentClick={handlePaymentClick}
                handleChannelToggle={handleChannelToggle}
                handleStatusToggle={handleStatusToggle}
                handleCategoryToggle={handleCategoryToggle}
                handleModelToggle={handleModelToggle}
                handleECUToggle={handleECUToggle}
                handleCountryToggle={handleCountryToggle}
                handleAPILevelToggle={handleAPILevelToggle}
                handlePaymentToggle={handlePaymentToggle}
                handleAllChannelsToggle={handleAllChannelsToggle}
                handleAllStatusToggle={handleAllStatusToggle}
                handleAllCategoryToggle={handleAllCategoryToggle}
                handleAllModelToggle={handleAllModelToggle}
                handleAllEcuToggle={handleAllEcuToggle}
                handleAllCountryToggle={handleAllCountryToggle}
                handleAllApilevelToggle={handleAllApilevelToggle}
                handleAllPaymentToggle={handleAllPaymentToggle}
                handleUnselectCategory={handleUnselectCategory}
                handleUnselectModel={handleUnselectModel}
                handleUnselectECU={handleUnselectECU}
                handleUnselectCountry={handleUnselectCountry}
                handleUnselectApiLevel={handleUnselectApiLevel}
                handleCategorySearch={handleCategorySearch}
                handleModelSearch={handleModelSearch}
                handleECUSearch={handleECUSearch}
                handleCountrySearch={handleCountrySearch}
                handleApiLevelSearch={handleApiLevelSearch}
                filteredCategory={filteredCategory}
                filteredModel={filteredModel}
                filteredECUTypes={filteredECUTypes}
                filteredCountry={filteredCountry}
                filteredApiLevel={filteredApiLevel}
              />
            )}
            {appType === "OEM Apps" && <div>Oem Apps</div> && (
             <OEMDrawerFilterOem
                categoryObjectList={categoryObjectList}
                modelObjectList={modelObjectList}
                countryObjectList={countryObjectList}
                ECUTypesObjectList={ECUTypesObjectList}
                apiObjectList={apiObjectList}
                channelOpen={channelOpen}
                setChannelOpen={setChannelOpen}
                statusOpen={statusOpen}
                setStatusOpen={setStatusOpen}
                categoryOpen={categoryOpen}
                setCategoryOpen={setCategoryOpen}
                modelOpen={modelOpen}
                setModelOpen={setModelOpen}
                ecuOpen={ecuOpen}
                setECUOpen={setECUOpen}
                countryOpen={countryOpen}
                setCountryOpen={setCountryOpen}
                ApiLevelOpen={ApiLevelOpen}
                setApiLevelOpen={setApiLevelOpen}
                paymentOpen={paymentOpen}
                setPaymentOpen={setPaymentOpen}
                channelListchecked={channelListchecked}
                setChannelListchecked={setChannelListchecked}
                statusListchecked={statusListchecked}
                setStatusListchecked={setStatusListchecked}
                categoryListChecked={categoryListChecked}
                setCategoryListChecked={setCategoryListChecked}
                modelListChecked={modelListChecked}
                setModelListChecked={setModelListChecked}
                ecuListchecked={ecuListchecked}
                setECUListchecked={setECUListchecked}
                countryListchecked={countryListchecked}
                setCountryListchecked={setCountryListchecked}
                apiLevelListchecked={apiLevelListchecked}
                setApiLevelListchecked={setApiLevelListchecked}
                paymentListchecked={paymentListchecked}
                setPaymentListchecked={setPaymentListchecked}
                searchCategory={searchCategory}
                setSearchCategory={setSearchCategory}
                searchModel={searchModel}
                setSearchModel={setSearchModel}
                searchECU={searchECU}
                setSearchECU={setSearchECU}
                searchCountry={searchCountry}
                setSearchCountry={setSearchCountry}
                searchApiLevel={searchApiLevel}
                setSearchApiLevel={setSearchApiLevel}
                selectAllCategoryFlag={selectAllCategoryFlag}
                setSelectAllCategoryFlag={setSelectAllCategoryFlag}
                selectAllModelFlag={selectAllModelFlag}
                setSelectAllModelFlag={setSelectAllModelFlag}
                selectAllCountryFlag={selectAllCountryFlag}
                setSelectAllCountryFlag={setSelectAllCountryFlag}
                selectAllECUFlag={selectAllECUFlag}
                setSelectAllECUFlag={setSelectAllECUFlag}
                selectAllApiFlag={selectAllApiFlag}
                setSelectAllApiFlag={setSelectAllApiFlag}
                channelType={channelType}
                statusArray={statusArray}
                paymentArray={paymentArray}
                handleChannelClick={handleChannelClick}
                handleStatusClick={handleStatusClick}
                handleCategoryClick={handleCategoryClick}
                handleModelClick={handleModelClick}
                handleECUClick={handleECUClick}
                handleCountryClick={handleCountryClick}
                handleApiLevelClick={handleApiLevelClick}
                handlePaymentClick={handlePaymentClick}
                handleChannelToggle={handleChannelToggle}
                handleStatusToggle={handleStatusToggle}
                handleCategoryToggle={handleCategoryToggle}
                handleModelToggle={handleModelToggle}
                handleECUToggle={handleECUToggle}
                handleCountryToggle={handleCountryToggle}
                handleAPILevelToggle={handleAPILevelToggle}
                handlePaymentToggle={handlePaymentToggle}
                handleAllChannelsToggle={handleAllChannelsToggle}
                handleAllStatusToggle={handleAllStatusToggle}
                handleAllCategoryToggle={handleAllCategoryToggle}
                handleAllModelToggle={handleAllModelToggle}
                handleAllEcuToggle={handleAllEcuToggle}
                handleAllCountryToggle={handleAllCountryToggle}
                handleAllApilevelToggle={handleAllApilevelToggle}
                handleAllPaymentToggle={handleAllPaymentToggle}
                handleUnselectCategory={handleUnselectCategory}
                handleUnselectModel={handleUnselectModel}
                handleUnselectECU={handleUnselectECU}
                handleUnselectCountry={handleUnselectCountry}
                handleUnselectApiLevel={handleUnselectApiLevel}
                handleCategorySearch={handleCategorySearch}
                handleModelSearch={handleModelSearch}
                handleECUSearch={handleECUSearch}
                handleCountrySearch={handleCountrySearch}
                handleApiLevelSearch={handleApiLevelSearch}
                filteredCategory={filteredCategory}
                filteredModel={filteredModel}
                filteredECUTypes={filteredECUTypes}
                filteredCountry={filteredCountry}
                filteredApiLevel={filteredApiLevel}
              />
            )}
            {appType === "3rd Party Apps" && <div>3rd Third Party</div> && (
              <OEMDrawerFilter3rdParty
                categoryObjectList={categoryObjectList}
                modelObjectList={modelObjectList}
                countryObjectList={countryObjectList}
                ECUTypesObjectList={ECUTypesObjectList}
                apiObjectList={apiObjectList}
                channelOpen={channelOpen}
                setChannelOpen={setChannelOpen}
                statusOpen={statusOpen}
                setStatusOpen={setStatusOpen}
                categoryOpen={categoryOpen}
                setCategoryOpen={setCategoryOpen}
                modelOpen={modelOpen}
                setModelOpen={setModelOpen}
                ecuOpen={ecuOpen}
                setECUOpen={setECUOpen}
                countryOpen={countryOpen}
                setCountryOpen={setCountryOpen}
                ApiLevelOpen={ApiLevelOpen}
                setApiLevelOpen={setApiLevelOpen}
                paymentOpen={paymentOpen}
                setPaymentOpen={setPaymentOpen}
                channelListchecked={channelListchecked}
                setChannelListchecked={setChannelListchecked}
                statusListchecked={statusListchecked}
                setStatusListchecked={setStatusListchecked}
                categoryListChecked={categoryListChecked}
                setCategoryListChecked={setCategoryListChecked}
                modelListChecked={modelListChecked}
                setModelListChecked={setModelListChecked}
                ecuListchecked={ecuListchecked}
                setECUListchecked={setECUListchecked}
                countryListchecked={countryListchecked}
                setCountryListchecked={setCountryListchecked}
                apiLevelListchecked={apiLevelListchecked}
                setApiLevelListchecked={setApiLevelListchecked}
                paymentListchecked={paymentListchecked}
                setPaymentListchecked={setPaymentListchecked}
                searchCategory={searchCategory}
                setSearchCategory={setSearchCategory}
                searchModel={searchModel}
                setSearchModel={setSearchModel}
                searchECU={searchECU}
                setSearchECU={setSearchECU}
                searchCountry={searchCountry}
                setSearchCountry={setSearchCountry}
                searchApiLevel={searchApiLevel}
                setSearchApiLevel={setSearchApiLevel}
                selectAllCategoryFlag={selectAllCategoryFlag}
                setSelectAllCategoryFlag={setSelectAllCategoryFlag}
                selectAllModelFlag={selectAllModelFlag}
                setSelectAllModelFlag={setSelectAllModelFlag}
                selectAllCountryFlag={selectAllCountryFlag}
                setSelectAllCountryFlag={setSelectAllCountryFlag}
                selectAllECUFlag={selectAllECUFlag}
                setSelectAllECUFlag={setSelectAllECUFlag}
                selectAllApiFlag={selectAllApiFlag}
                setSelectAllApiFlag={setSelectAllApiFlag}
                channelType={channelType}
                statusArray={statusArray}
                paymentArray={paymentArray}
                handleChannelClick={handleChannelClick}
                handleStatusClick={handleStatusClick}
                handleCategoryClick={handleCategoryClick}
                handleModelClick={handleModelClick}
                handleECUClick={handleECUClick}
                handleCountryClick={handleCountryClick}
                handleApiLevelClick={handleApiLevelClick}
                handlePaymentClick={handlePaymentClick}
                handleChannelToggle={handleChannelToggle}
                handleStatusToggle={handleStatusToggle}
                handleCategoryToggle={handleCategoryToggle}
                handleModelToggle={handleModelToggle}
                handleECUToggle={handleECUToggle}
                handleCountryToggle={handleCountryToggle}
                handleAPILevelToggle={handleAPILevelToggle}
                handlePaymentToggle={handlePaymentToggle}
                handleAllChannelsToggle={handleAllChannelsToggle}
                handleAllStatusToggle={handleAllStatusToggle}
                handleAllCategoryToggle={handleAllCategoryToggle}
                handleAllModelToggle={handleAllModelToggle}
                handleAllEcuToggle={handleAllEcuToggle}
                handleAllCountryToggle={handleAllCountryToggle}
                handleAllApilevelToggle={handleAllApilevelToggle}
                handleAllPaymentToggle={handleAllPaymentToggle}
                handleUnselectCategory={handleUnselectCategory}
                handleUnselectModel={handleUnselectModel}
                handleUnselectECU={handleUnselectECU}
                handleUnselectCountry={handleUnselectCountry}
                handleUnselectApiLevel={handleUnselectApiLevel}
                handleCategorySearch={handleCategorySearch}
                handleModelSearch={handleModelSearch}
                handleECUSearch={handleECUSearch}
                handleCountrySearch={handleCountrySearch}
                handleApiLevelSearch={handleApiLevelSearch}
                filteredCategory={filteredCategory}
                filteredModel={filteredModel}
                filteredECUTypes={filteredECUTypes}
                filteredCountry={filteredCountry}
                filteredApiLevel={filteredApiLevel}
                appType={appType}
              />
            )}
          </div>
          <div
            className="filterFooterCls"
            style={{
              position: "relative",
              marginTop: "auto",
              flexShrink: 0,
            }}
          >
            <Button
              onClick={handleResetChange}
              color="primary"
              sx={{
                textTransform: "none",
                background: "#1214151A",
                color: "#2A2C2D",
              }}
            >
              Reset To Default
            </Button>
            <div>
              <Button
                onClick={toggleDrawer(false)}
                color="primary"
                sx={{
                  textTransform: "none",
                  background: "#1214151A",
                  color: "#2A2C2D",
                }}
              >
                Cancel
              </Button>
              &nbsp;&nbsp;
              <Button
                color="primary"
                variant="contained"
                sx={{ textTransform: "none" }}
                onClick={handleApplyFilters}
                disabled={
                  channelListchecked.length === 0 ||
                  statusListchecked.length === 0 ||
                  categoryListChecked.length === 0 ||
                  modelListChecked.length === 0 ||
                  countryListchecked.length === 0 ||
                  apiLevelListchecked.length === 0 ||
                  paymentListchecked.length === 0
                }
              >
                Apply
              </Button>
            </div>
          </div>
        </div>
      </Drawer>
      <PopupDialog
        openErrorPopup={openErrorPopup}
        errorMessage={errorMessage}
        headerMessage={headerMessage}
        componentName={componentName}
        onClose={handlePopUpClose}
      />
    </>
  );
};

OEMDrawerFilter.propTypes = {
  openFilter: PropTypes.bool.isRequired,
  toggleDrawer: PropTypes.func.isRequired,
  categoryObjectList: PropTypes.object.isRequired,
  modelObjectList: PropTypes.object.isRequired,
  handleFilterApiCalls: PropTypes.func.isRequired,
  channelListchecked: PropTypes.arrayOf(PropTypes.string).isRequired,
  setChannelListchecked: PropTypes.func.isRequired,
  channelSelections: PropTypes.object.isRequired,
  setChannelSelections: PropTypes.func.isRequired,
  categorySelection: PropTypes.object.isRequired,
  setCategorySelection: PropTypes.func.isRequired,
  modelSelections: PropTypes.object.isRequired,
  setModelSelections: PropTypes.func.isRequired,
  paymentSelections: PropTypes.object.isRequired,
  setPaymentSelections: PropTypes.func.isRequired,
  countrySelections: PropTypes.object.isRequired,
  setCountrySelections: PropTypes.func.isRequired,
  statusSelections: PropTypes.object.isRequired,
  setStatusSelections: PropTypes.func.isRequired,
  apiLevelSelections: PropTypes.object.isRequired,
  setApiLevelSelections: PropTypes.func.isRequired,
  ecuTypeSelections: PropTypes.object.isRequired,
  setEcuTypeSelections: PropTypes.func.isRequired,
};
